<template>
  <b-modal
    id="modalCambioPasswordObligatorio"
    :visible="visible"
    size="lg"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    modal-class="db-modal"
  >
    <template #modal-header>
      <div class="db-modal-head">
        <h2 class="db-modal-title">Cambia tu contraseña</h2>
        <p class="db-modal-subtitle">
          Estás usando una contraseña asignada por un administrador. Elige una nueva para continuar.
        </p>
      </div>
    </template>

    <form-cambio-password @cambiada="$emit('cambiada', $event)">
      <template #extra-actions>
        <button type="button" class="db-btn db-btn--ghost" @click="$emit('salir')">Cerrar sesión</button>
      </template>
    </form-cambio-password>
  </b-modal>
</template>

<script>
import FormCambioPassword from "@/components/dashboard/usuarios/FormCambioPassword.vue";

export default {
  name: "ModalCambioPasswordObligatorio",

  components: { FormCambioPassword },

  props: {
    visible: { type: Boolean, default: false },
  },
};
</script>
